import {gql} from "@apollo/client";

const requestPasswordResetMutation = gql`
    mutation RequestPasswordResetMutation(
        $email: String!
        $redirectUrl: String!
        $rootUrl: RootURLEnum
        $marketplaceSlug: String
        $universitySlug: String
        $captureToken: String
    ) {
        requestPasswordReset(
            email: $email
            redirectUrl: $redirectUrl
            rootUrl: $rootUrl
            marketplaceSlug: $marketplaceSlug
            universitySlug: $universitySlug
            captureToken: $captureToken
        ) {
            success
        }
    }
`;

export default requestPasswordResetMutation;
